import { type FC } from 'react';
import { type EdgeProps } from 'reactflow';
import type { LinkData } from '@/types/link.types';

const CONTRADICTION_COLOR = '#EF4444';

/**
 * Contradiction edge renders as a red zigzag line between nodes.
 */
export const ContradictionEdge: FC<EdgeProps<LinkData>> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  markerEnd,
  style,
}) => {
  // Generate zigzag path
  const dx = targetX - sourceX;
  const dy = targetY - sourceY;
  const dist = Math.sqrt(dx * dx + dy * dy);
  const segments = Math.max(4, Math.floor(dist / 20));
  const amplitude = 6;

  let path = `M ${sourceX} ${sourceY}`;

  for (let i = 1; i <= segments; i++) {
    const t = i / segments;
    const x = sourceX + dx * t;
    const y = sourceY + dy * t;

    // Perpendicular offset for zigzag
    const perpX = -dy / dist;
    const perpY = dx / dist;
    const offset = i % 2 === 0 ? amplitude : -amplitude;

    if (i < segments) {
      path += ` L ${x + perpX * offset} ${y + perpY * offset}`;
    } else {
      path += ` L ${x} ${y}`;
    }
  }

  return (
    <path
      id={id}
      d={path}
      fill="none"
      stroke={CONTRADICTION_COLOR}
      strokeWidth={2}
      markerEnd={markerEnd}
      style={style}
    />
  );
};

export default ContradictionEdge;
